module.exports = __webpack_public_path__ + "img/kf_logo.c73fcfae.png";